import type { InstallationJob } from '../types';

export function shouldShowIqReview(job: InstallationJob, canReviewIq: boolean): boolean {
  if (!canReviewIq) return false;

  const hasSubmittedDraft = job.sensors.some(
    (sensor) => sensor.iqDraft?.status === 'submitted' || sensor.iqDraft?.status === 'created',
  );

  return hasSubmittedDraft
    || (job.status === 'completed' && job.sensors.some((sensor) => sensor.installed));
}
